"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = require("react-bootstrap/lib/Row");

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** A set of columns to guide element placement
 */
var Row = function Row(_ref) {
  var children = _ref.children,
      htmlId = _ref.htmlId,
      props = _objectWithoutProperties(_ref, ["children", "htmlId"]);

  delete props.bsClass;

  return _react2.default.createElement(
    _Row2.default,
    Object.assign({ id: htmlId }, props),
    children
  );
};

Row.propTypes = {
  /** Base CSS class and prefix for the component. */
  bsClass: _propTypes2.default.string,

  /** Any child components. */
  children: _propTypes2.default.node,

  /** Component className. */
  className: _propTypes2.default.string,

  /** You can use a custom element for this component. */
  componentClass: _propTypes2.default.string,

  /** Globally unique and descriptive HTML ID. Used by QA for automated testing. */
  htmlId: _propTypes2.default.string
};

Row.defaultProps = {
  componentClass: "div"
};

exports.default = Row;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/Row/Row.js
// module id = 503
// module chunks = 0